import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';
import { QRCodeSVG } from 'qrcode.react';

import { getChallengeSharePath } from '../../../utils/routes';
import texts from '../texts.json';
import Confetti from './Confetti';
import {
  Body,
  HandoffLayout,
  HandoffPanel,
  HandoffStage,
  HandoffTop,
  Proof,
  QrCard,
  QrFrame,
  QrText,
  StickerImage,
  TagDot,
  TaskTag,
  TextButton,
  Title,
  getFlowColors,
} from './styles';

/*
  Instagram Stories are posted from a phone, so a computer shows the sticker waiting for its photo and a code that
  opens the challenge's public share page on the phone. That page shows the same steps and nothing about the client.
*/
const PhoneHandoff = ({
  card,
  stickerUrl,
  onSkip,
  footer,
}) => (
  <HandoffLayout style={getFlowColors(card)} aria-label={card.challengeName}>
    <HandoffStage>
      <Confetti />
      {!!stickerUrl && <StickerImage src={stickerUrl} alt={texts.done.sticker} $width={300} $tilt={-3} />}
    </HandoffStage>
    <HandoffPanel>
      <HandoffTop>
        <TaskTag>
          <TagDot />
          {format(texts.taskTag, { challengeName: card.challengeName.toUpperCase() })}
        </TaskTag>
        <TextButton type="button" onClick={onSkip}>{texts.skipForNow}</TextButton>
      </HandoffTop>
      <Title $size={44}>{texts.make.title}</Title>
      <Body>{texts.phone.body}</Body>
      <QrCard aria-labelledby="story-phone-title">
        <QrFrame>
          <QRCodeSVG
            value={`${window.location.origin}${getChallengeSharePath(card.challengeId)}`}
            size={102}
            title={texts.phone.code}
            role="img"
            aria-label={texts.phone.code}
          />
        </QrFrame>
        <QrText>
          <strong id="story-phone-title">{texts.phone.title}</strong>
          {texts.phone.scan}
        </QrText>
      </QrCard>
      <Proof $align="left">
        {`${texts.done.proofLead} `}
        <strong>{texts.done.proof}</strong>
      </Proof>
      {footer}
    </HandoffPanel>
  </HandoffLayout>
);

PhoneHandoff.propTypes = {
  card: PropTypes.shape({
    challengeId: PropTypes.string.isRequired,
    challengeName: PropTypes.string.isRequired,
    brandColor: PropTypes.string.isRequired,
    isDarkTheme: PropTypes.bool.isRequired,
  }).isRequired,
  // The sticker waiting for its photo, once it is drawn.
  stickerUrl: PropTypes.string,
  onSkip: PropTypes.func.isRequired,
  // What the page adds under the code, such as the email the account is linked to.
  footer: PropTypes.node,
};

PhoneHandoff.defaultProps = {
  stickerUrl: null,
  footer: null,
};

export default PhoneHandoff;
